import {Component, OnInit} from '@angular/core'
import {ActivatedRoute } from '@angular/router'

import { AuthService } from '../../insa-services'

@Component({
  template: '<insaweb-newhome></insaweb-newhome>'
   //template: '<div>TOKEN: {{ token }}</div>'  // '<insaweb-newhome></insaweb-newhome>'
})
export class EmbeddedLoginComponent implements OnInit {
  private token = 'NO_TOKEN';
  constructor(private _authService: AuthService, private route: ActivatedRoute) {
  }

  ngOnInit () {
    let routeSnapshot = this.route.snapshot;
    if (routeSnapshot.queryParamMap.has('accessToken')) {
      this.token = routeSnapshot.queryParamMap.get('accessToken');
      if (!this._authService.embeddedLogin(this.token)) {
        console.log('ERROR: invalid access token provided!')
        // this._router.navigateByUrl('/login'); // error occured
      }
    } else {
      // this._router.navigateByUrl('/login');
    }
  }

}


// WEBPACK FOOTER //
// ./app/insa-components/insa-login/embedded-login.component.ts